import React, { useState } from "react";
import { toast } from "react-toastify";
import { PhoneOff, ThumbsUp, FileText, XCircle } from "lucide-react";
import CrmLossReasonModal from "./CrmLossReasonModal";
import { buildLossExtra1 } from "../../utils/crmLossReason";

const ACTION_META = {
  called_no_answer: { icon: PhoneOff, label: "No answer" },
  interested: { icon: ThumbsUp, label: "Interested" },
  send_quote: { icon: FileText, label: "Send quote" },
  not_interested: { icon: XCircle, label: "Not interested", needsLossReason: true },
};

const CrmQuickActions = ({ leadId, leadName, url, token, onDone, compact = false }) => {
  const [busy, setBusy] = useState(null);
  const [lossModalOpen, setLossModalOpen] = useState(false);

  const run = async (action, lossExtra1 = null) => {
    if (!leadId || busy) return;
    setBusy(action);
    try {
      const res = await fetch(`${url}/leads/quick-action/${leadId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ action, loss_extra1: lossExtra1 }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.message || "Action failed");
      toast.success(data.action || "Logged");
      onDone?.(data.lead);
    } catch (err) {
      toast.error(err.message || "Could not log action");
    } finally {
      setBusy(null);
    }
  };

  const handleClick = (key) => {
    if (ACTION_META[key]?.needsLossReason) {
      setLossModalOpen(true);
      return;
    }
    run(key);
  };

  const confirmLoss = async (reasonId, note) => {
    setLossModalOpen(false);
    await run("not_interested", buildLossExtra1(reasonId, note));
  };

  return (
    <>
      <div className={`crm-quick-actions ${compact ? "crm-quick-actions--compact" : ""}`}>
        {Object.entries(ACTION_META).map(([key, meta]) => {
          const Icon = meta.icon;
          return (
            <button
              key={key}
              type="button"
              title={meta.label}
              disabled={Boolean(busy)}
              onClick={() => handleClick(key)}
              className={busy === key ? "is-busy" : ""}
            >
              <Icon size={compact ? 12 : 14} />
              {!compact && <span>{meta.label}</span>}
            </button>
          );
        })}
      </div>

      <CrmLossReasonModal
        open={lossModalOpen}
        leadName={leadName}
        onConfirm={confirmLoss}
        onCancel={() => setLossModalOpen(false)}
        saving={busy === "not_interested"}
      />
    </>
  );
};

export default CrmQuickActions;
